export enum SkuCategory {
    Topup = 1, Data = 2, Bundle = 3, Pin = 10, GiftCard = 11
}
export enum ProductCategory {
    Topup = 1, Pin = 10, GiftCard = 11
}
export enum GiftCardCategory {
    NotApplicable = 0, // to handle default value for int
    OnlineShopping = 1, Games = 2, Utility = 3, CashCards = 4, Travel = 5, Beauty = 6, HomeImprovement = 7, Restaurant = 8,
    FoodAndBeverage = 9, MoviesAndEntertainment = 10, GroceryAndPharmacy = 11, SportsAndOutdoors = 12
}
export enum BlockItemType {
    User = 1, IPAddress = 2, MobileNumber = 3
}
export enum RecurringProfileStatus {
    PendingPayment = 0,
    Active = 1,
    Cancelled = 2,
    Rejected = 3,
    PaymentRejected = 4,    // This is temporary fix for existing data.
    PendingApproval = 5,
}

export enum Frequency {
    Weekly,
    BiWeekly,
    Monthly,
}

export enum PromotionType {
    GeneralDiscount,
    RewardPoints,
    PromoCodeDiscount,
    PromoCodePoints,
    ReferrerDiscount,
    ReferrerPoints,
    RefereeDiscount,
    RefereePoints
}
export enum AwardType {
    Discount, Points
}
export enum DiscountType {
    Fixed, Percentage
}
export enum PaymentStatus {
    Pending = 0, Suspended = 1, OnHold = 2, Successful = 3, Failed = 4, Refunded = 5, RefundFailed = 6, ChargeBack = 7, Authorized = 9, Released = 10 
}
export enum FraudStatus {
    Pending = 0, VerificationRequired = 1, NoVerificationRequired = 2, Verified = 3, Blocked = 4
}
export enum RechargeStatus {
    Pending = 0, Successful = 1, Failed = 2, Transient = 3, Timeout = 4
}
export enum PaymentMethod {
    RewardPoint, CreditCard, PayPal, Other
}
export enum ReconStatus {
    Pending = 0, Successuful = 1, MissingAtProc = 2, MissingAtSystem = 3, ChargePartOnly = 4, RefundPartOnly = 5
}
export enum UserStatus {
    Unveriefied = 0, Verified = 1, Trusted = 2, Inactive = 3
}
export enum FraudSource {
    None = 1, System = 2, User = 4, CyberSource = 8, NoFraud = 16
}
function getPaymentStatusValues() {
    const payment2: Map<number, { shortName: string, name: string }> = new Map<number, { shortName: string, name: string }>();
    payment2.set(PaymentStatus.Pending, { shortName: 'P', name: 'Pending' });
    payment2.set(PaymentStatus.Suspended, { shortName: 'Sus', name: 'Suspended' });
    payment2.set(PaymentStatus.OnHold, { shortName: 'H', name: 'OnHold' });
    payment2.set(PaymentStatus.Successful, { shortName: 'S', name: 'Successful' });
    payment2.set(PaymentStatus.Failed, { shortName: 'F', name: 'Failed' });
    payment2.set(PaymentStatus.Refunded, { shortName: 'R', name: 'Refunded' });
    payment2.set(PaymentStatus.RefundFailed, { shortName: 'RF', name: 'RefundFailed' });
    payment2.set(PaymentStatus.ChargeBack, { shortName: 'CB', name: 'ChargeBack' });
    return payment2;
}
function getFraudStatusValues() {
    const fraud2: Map<number, { shortName: string, name: string }> = new Map<number, { shortName: string, name: string }>();
    fraud2.set(FraudStatus.Pending, { shortName: 'P', name: 'Pending' });
    fraud2.set(FraudStatus.VerificationRequired, { shortName: 'VR', name: 'VerificationRequired' });
    fraud2.set(FraudStatus.NoVerificationRequired, { shortName: 'NVR', name: 'NoVerificationRequired' });
    fraud2.set(FraudStatus.Verified, { shortName: 'V', name: 'Verified' });
    fraud2.set(FraudStatus.Blocked, { shortName: 'B', name: 'Blocked' });
    return fraud2;
}
function getRechargeStatusValues() {
    const recharge2: Map<number, { shortName: string, name: string }> = new Map<number, { shortName: string, name: string }>();
    recharge2.set(RechargeStatus.Pending, { shortName: 'P', name: 'Pending' });
    recharge2.set(RechargeStatus.Successful, { shortName: 'S', name: 'Successful' });
    recharge2.set(RechargeStatus.Failed, { shortName: 'F-P', name: 'Failed' });
    recharge2.set(RechargeStatus.Transient, { shortName: 'F-T', name: 'Transient' });
    recharge2.set(RechargeStatus.Timeout, { shortName: 'T-O', name: 'Timeout' });
    return recharge2;
}
function getUserStatusValues() {
    const userStatus2: Map<number, { shortName: string, name: string }> = new Map<number, { shortName: string, name: string }>();
    userStatus2.set(UserStatus.Unveriefied, { shortName: 'U', name: 'Unverified' });
    userStatus2.set(UserStatus.Verified, { shortName: 'V', name: 'Verified' });
    userStatus2.set(UserStatus.Trusted, { shortName: 'T', name: 'Trusted' });
    userStatus2.set(UserStatus.Inactive, { shortName: 'I', name: 'Inactive' });
    return userStatus2;
}

export const payment = getPaymentStatusValues();
export const fraud = getFraudStatusValues();
export const recharge = getRechargeStatusValues();
export const userStatus = getUserStatusValues();
